import { Card } from "@/components/card";
import { Button } from "@/components/ui/button";

import { useUpdatePhoneNumber } from "../api/update-phone-number";

import { SavePhoneForm } from "./save-phone.form";
import { VerifyPhoneForm } from "./verify-phone.form";

type SMS2FAForm = {
  goBack: () => void;
  onSuccess: () => Promise<void>;
};

export function SMS2FAForm({ goBack, onSuccess }: SMS2FAForm) {
  const { mutateAsync, isSuccess } = useUpdatePhoneNumber();

  return (
    <Card>
      <Card.Header
        title="Setup 2FA"
        description="Select your preferred method"
      />
      <Card.Content className="space-y-6">
        <p className="text-md font-normal text-secondary">
          When signing in, you will need to enter a verification code sent to
          this phone number as an additional step.
        </p>
        <SavePhoneForm onSubmit={mutateAsync} />
        {isSuccess && (
          <>
            <p className="text-md font-normal text-secondary">
              A text message containing a verification code will be sent to this
              phone number. Message and data rates may apply.
            </p>
            <VerifyPhoneForm onSuccess={onSuccess} />
          </>
        )}
      </Card.Content>
      <Card.Footer className="flex items-center justify-between">
        <p className="text-sm text-secondary">Step 2 of 2</p>
        <div className="flex gap-2">
          <Button type="button" variant="outline" onClick={goBack}>
            Back
          </Button>
          <Button type="submit" disabled={!isSuccess} form="verify-phone">
            Verify
          </Button>
        </div>
      </Card.Footer>
    </Card>
  );
}
